export { default as ImmadiateDeliveryIcon } from "./immediate_delivery.svg";
export { default as PartialPaymentIcon } from "./partial_payment.svg";
export { default as DeprecationIcon } from "./deprecation.svg";
export { default as RateIcon } from "./rate.svg";
export { default as CashIcon } from "./cash.svg";
export { default as InstalmentIcon } from "./instalment.svg";
export { default as InterestIcon } from "./interest.svg";
export { default as DelayIcon } from "./delay.svg";
export { default as DepletableIcon } from "./depletable.svg";
export { default as BankLoanIcon } from "./bank-loan.svg";
